export var PAGE_NAME = {
    None: 'none',
    Calendar: 'cal',
    EntryForm: 'form',
    EntryForm2: 'form2',
    Product: 'product',
    Payment: 'payment',
};
export var DATETIME_FORMAT = {
    // 2022-02-06T00:00:00+09:00
    FOR_API: "yyyy-MM-dd'T'HH:mm:ssxxx",
    DATE_TIME: 'yyyy-MM-dd HH:mm',
    HHMM: 'H:m',
    MMDD: 'M/d',
    DAY_OF_WEEK: 'eee',
    YYYYMMDD_JP: 'yyyy年 M月 d日',
    YYYYMMDD_HHMM_JP: 'yyyy年 M月 d日 HH時 mm分',
};
export var SCHEDULE_STATUS_CNST = {
    None: 0,
    Possible: 1,
    Full: 2,
    Paid: 3,
};
export var SCHEDULE_STATUS_KBN = {
    0: '',
    1: '空',
    2: '満',
    3: '満',
};
export var PAYMENT_METHOD_CONST = {
    CARD: 1,
    COUPON: 2,
    SUBSCRIPTION: 3,
};
